<template>
  <el-drawer class="user-detail" :visible.sync="drawerVisible" :show-close="false" :before-close="handleCloseDrawer" size="70%">
    <ts-detail-tab :btn-list="btnList" :tab-info="tabInfo" :header-info="headerInfo" :is-open="drawerVisible" @on-edit-change="handleEditChange" />
  </el-drawer>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import TsDetailTab from '@/components/TsDetailTab/index'
import { changeUserFlag } from '@/api/manage/userManage'
@Component({
  name: 'detailDrawer',
  components: {
    TsDetailTab
  }
})
export default class extends Vue {
  @Prop({ default: false }) value
  @Prop({ default: Object }) headerInfo
  @Prop({ default: Object }) searchFormData
  @Prop({ default: Array }) allActivationList
  @Prop({ default: Array }) allRolesList
  editStatus = false
  btnList = [
    {
      type: 'switch',
      value: true,
      btnFuc: this.handleSwitchChange
    }
  ]

  tabInfo = {
    activeName: 'one',
    options: [
      {
        label: '用户管理',
        active: 'one',
        name: 'EditUserMsg',
        dataObj: {
          isEcho: true,
          formList: [
            {
              label: '用户姓名',
              prop: 'name',
              type: 'input',
              rules: [
                { required: true, message: '用户姓名不能为空' }
              ],
              isEdit: true,
              placeholder: '请输入有效姓名' // 如果需要就加上 默认为''
            },
            {
              label: '用户账号/手机号',
              prop: 'mobile',
              type: 'input',
              isEdit: true,
              // isNumber: true, // input类型的如果为数字输入框需要加上
              rules: [
                { required: true, message: '用户账号/手机号不能为空' },
                // { type: 'number', message: '用户账号/手机号必须为数字值'},
                { pattern: /^(((13[0-9])|(15[0-9])|(16[0-9])|(17[3-8])|(18[0-9])|(19[0-9])|(14[5-7]))+\d{8})$/, message: '用户账号/手机号格式错误', trigger: 'blur' }
              ] // 若为必填字段需要加上
            },
            {
              label: '用户职位',
              prop: 'positionName',
              isEdit: true,
              rules: [
                { required: true, message: '用户职位不能为空' }
              ],
              type: 'input',
              placeholder: '请输入有效职位' // 如果需要就加上 默认为''
            },
            {
              label: '用户邮箱',
              prop: 'email',
              type: 'input',
              isEdit: true,
              rules: [
                { required: true, message: '用户邮箱不能为空' },
                { pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/, message: '邮箱格式错误', trigger: 'blur' }
              ],
              placeholder: '请输入有效邮箱' // 如果需要就加上 默认为''
            },
            {
              label: '选择许可证',
              isEdit: true,
              prop: 'activationCodeIds',
              type: 'select',
              multiple: true, // 是否多选 默认false
              rules: [{ required: true, type: 'array', message: '绑定许可证不能为空', trigger: 'blur' }],
              options: []// select类型的需要options
            },
            {
              label: '绑定许可证',
              isEdit: true,
              prop: 'activationCodeId',
              type: 'select',
              rules: [{ required: true, message: '绑定许可证不能为空', trigger: 'blur' }],
              options: []// select类型的需要options
            },
            {
              label: '用户角色',
              prop: 'userRoles',
              type: 'select',
              isEdit: true,
              multiple: true, // 是否多选 默认false
              options: [] // select类型的需要options
              // rules: [{ required: true, type: 'array', message: '用户角色不能为空', trigger: 'blur' }]
            }
          ]
        }
      },
      {
        label: '许可证信息',
        name: 'PermissionMsg',
        active: 'two',
        dataObj: {}
      }
    ]
  }

  drawerVisible = false
  @Watch('value')
  onValueChanged (newVal) {
    console.log(this.searchFormData)
    if (newVal) {
      this.btnList[0].value = this.searchFormData.flag
      this.tabInfo.activeName = 'one'
      if (this.allActivationList.length) {
        this.tabInfo.options[0].dataObj.formList[4].options = this.allActivationList.map(item => {
          item = Object.assign({}, item, {
            anotherName: item.name + '  剩余' + item.availableCounts + '个'
          })
          if (!item.availableCounts) {
            item = Object.assign({}, item, {
              disabled: true
            })
          }
          return item
        })
        if (this.searchFormData.activationCodeIds.length) {
          this.searchFormData.activationCodeIds.forEach(item => {
            this.tabInfo.options[0].dataObj.formList[4].options.map(op => {
              if (op.id === item) {
                op.disabled = true
              }
            })
          })
        }
      }
      console.log(this.tabInfo.options[0].dataObj.formList[5].options)
      if (this.searchFormData.userActivationCodes.length) {
        this.searchFormData.userActivationCodes.forEach(item => {
          const { activationCodeId, activationKey, remainDays } = item
          this.tabInfo.options[0].dataObj.formList[5].options.push({
            id: activationCodeId,
            name: activationKey,
            anotherName: activationKey + '  剩余' + remainDays + '天'
          })
        })
      }
      console.log(this.tabInfo.options[0].dataObj.formList[5].options)
      const roleList = []
      if (this.searchFormData.userRoles.length) {
        this.searchFormData.userRoles.forEach(item => {
          roleList.push(item.roleId)
        })
      }
      // this.tabInfo.options[0].dataObj.formList[4].options = this.allActivationList
      this.tabInfo.options[0].dataObj.formList[6].options = this.allRolesList
      this.tabInfo.options[0].dataObj.searchFormData = {
        id: this.searchFormData.id,
        tenantId: this.searchFormData.tenantId,
        name: this.searchFormData.name,
        mobile: this.searchFormData.mobile,
        activationCodeIds: this.searchFormData.activationCodeIds || [],
        positionName: this.searchFormData.positionName,
        activationCodeId: this.searchFormData.activationCodeId,
        userRoles: roleList,
        email: this.searchFormData.email
      } // 回显数据
      this.tabInfo.options[1].dataObj.searchFormData = this.tabInfo.options[0].dataObj.searchFormData
      console.log(this.tabInfo.options[1].dataObj.searchFormData)
    }
    this.drawerVisible = newVal
  }

  handleCloseDrawer () {
    if (this.editStatus) {
      this.$confirm('还有未保存的工作,确定关闭吗？')
        .then(() => {
          this.drawerVisible = false
          this.$emit('input', false)
          this.$emit('on-close')
        })
        .catch((err) => { console.log(err) })
    } else {
      this.drawerVisible = false
      this.$emit('input', false)
      this.$emit('on-close')
    }
  }

  handleBack () {
    this.handleCloseDrawer()
  }

  handleSwitchChange (val) {
    console.log(val)
    const params = {
      flag: val,
      id: this.searchFormData.id
    }
    changeUserFlag(params).then(res => {
      if (res.statusCode === 0 && res.success) {
        this.$message({
          message: `${!val ? '该用户已启用' : '该用户已禁用'}`,
          type: `${!val ? 'success' : ''}`
        })
      }
    })
  }

  handleEditChange (value) {
    this.editStatus = value
  }
}
</script>

<style lang="scss">
.user-detail {
  .el-drawer__header {
    margin: 0;
  }
}
</style>
